"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLink = void 0;
var _mui = require("@ori-ui/mui");
const StyledLink = exports.StyledLink = (0, _mui.styled)(_mui.Link)(({
  theme
}) => ({
  color: theme.palette.default.main,
  fontWeight: theme.typography.fontWeightBold,
  '&:hover': {
    color: theme.palette.primary.main,
    cursor: 'pointer',
    textDecoration: 'underline'
  }
}));
